import { render, staticRenderFns } from "./RegisterPreferences.vue?vue&type=template&id=810c9962&scoped=true&"
import script from "./RegisterPreferences.vue?vue&type=script&lang=js&"
export * from "./RegisterPreferences.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPreferences.vue?vue&type=style&index=0&id=810c9962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c9962",
  null
  
)

export default component.exports